import { useEffect, useState } from 'react';
import axios from '../../../sharedModules/utils/axios.utils';
import { AnalyticsSummary, AnalyticsWindow } from '../model';

const useAnalyticsSummary = (selectedWindow: AnalyticsWindow) => {
  const [data, setData] = useState<AnalyticsSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    // A slow response for a previously selected window must not overwrite the current one.
    let current = true;
    setLoading(true);
    setError(false);
    axios
      .get<AnalyticsSummary>('/admin/analytics', { params: { window: selectedWindow } })
      .then((response) => {
        if (current) setData(response.data);
      })
      .catch((err) => {
        if (!current) return;
        setError(true);
        console.warn('Failed to load the analytics summary', err);
      })
      .finally(() => {
        if (current) setLoading(false);
      });
    return () => {
      current = false;
    };
  }, [selectedWindow, attempt]);

  const retry = () => setAttempt((count) => count + 1);

  return { data, loading, error, retry };
};

export default useAnalyticsSummary;
